const pipe = function (initialArgStruct, methods) {
    let argStruct = Object.assign({}, initialArgStruct);

    methods.forEach(method => {
        argStruct = method(argStruct);
    });

    return argStruct;
};

export default pipe;



// WEBPACK FOOTER //
// ./assets/js/utils/pipe.js